import { useState } from 'react'
import { Button, Dialog, Table, Text } from '@/ui'
import { DateTime } from 'luxon'

import { UserWithAdminInfo } from '@/reducers/admin/allUsersReducer'
import {
  adminDeleteUserImportantDate,
  UserImportantDate,
} from '@/features/user/dashboard/user-important-dates/userImportantDates.slice'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'

const UserImportantDateRow = ({
  userImportantDate,
  user,
}: {
  userImportantDate: UserImportantDate
  user: UserWithAdminInfo
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const dispatch = useAppDispatch()
  const removeAction = async () => {
    const res = await adminDeleteUserImportantDate(
      userImportantDate.id,
      user.id
    )(dispatch)
    if (res) {
      setConfirmOpen(false)
    }
  }

  return (
    <Table.Row>
      <Table.Cell>{userImportantDate.id}</Table.Cell>
      <Table.Cell>{userImportantDate.actionItem.description}</Table.Cell>
      <Table.Cell>
        {userImportantDate.actionItem.actionItemCategory?.title}
      </Table.Cell>
      <Table.Cell>
        {userImportantDate.createdAt &&
          DateTime.fromISO(userImportantDate.createdAt).toFormat(
            DATE_FORMATS_LUXON.DISPLAY_SHORT
          )}
      </Table.Cell>
      <Table.Cell className={!userImportantDate.readAt ? 'text-red-500' : ''}>
        {userImportantDate.readAt &&
          DateTime.fromISO(userImportantDate.readAt).toFormat(
            DATE_FORMATS_LUXON.DISPLAY_SHORT
          )}
      </Table.Cell>
      <Table.Cell>
        <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
          <Dialog.Trigger>
            <Button variant="link" onClick={() => setConfirmOpen(true)}>
              Remove
            </Button>
          </Dialog.Trigger>
          <Dialog.Content>
            <Dialog.Header>
              <Text variant={TypographyStyles.H3}>Remove Date</Text>
            </Dialog.Header>
            Are you sure you want to remove this date from the User&apos;s
            Dashboard?
            <br />
            <Dialog.Footer className="mt-4">
              <Button onClick={() => setConfirmOpen(false)} variant="link">
                Cancel
              </Button>
              <Button onClick={() => removeAction()} variant="danger">
                Remove Date
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog>
      </Table.Cell>
    </Table.Row>
  )
}
export const UserImportantDatesTable = ({
  importantDates,
  user,
}: {
  importantDates: UserImportantDate[]
  user: UserWithAdminInfo
}) => {
  return (
    <Table compact="very" className="w-full">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Id</Table.HeaderCell>
          <Table.HeaderCell>Todo Name</Table.HeaderCell>
          <Table.HeaderCell>Category</Table.HeaderCell>
          <Table.HeaderCell>Assigned On</Table.HeaderCell>
          <Table.HeaderCell>Completed On</Table.HeaderCell>
          <Table.HeaderCell>Delete</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {importantDates.map((item, key) => {
          return (
            <UserImportantDateRow
              userImportantDate={item}
              user={user}
              key={key}
            />
          )
        })}
      </Table.Body>
    </Table>
  )
}
